import LegalPage from "@/components/LegalPage";
import { Link } from "react-router-dom";

/**
 * /cancellation — Widerrufsbelehrung für Verbraucher (Platzhalter-Entwurf).
 *
 * ⚠️ NON-PUBLIC NOTICE:
 * Legal pages contain placeholders and must not be considered final until
 * operator data is inserted and reviewed.
 *
 * TODO: Legal review required before enabling paid checkout.
 * TODO: Der endgültige Wortlaut für digitale Dienstleistungen und den
 * Verlust des Widerrufsrechts nach Beginn der Ausführung (inkl.
 * Einwilligungs- und Bestätigungs-Flow im Checkout) ist vor Aktivierung
 * des bezahlpflichtigen Checkouts rechtlich zu prüfen.
 */
export default function Cancellation() {
  return (
    <LegalPage
      title="Widerrufsbelehrung"
      subtitle="Informationen zum gesetzlichen Widerrufsrecht für Verbraucher bei kostenpflichtigen Abonnements von PineForge.AI."
      updatedAt="05.07.2026"
    >
      <Section title="Widerrufsrecht">
        <p>
          Sie haben das Recht, binnen <strong>14 Tagen</strong> ohne Angabe
          von Gründen diesen Vertrag zu widerrufen.
        </p>
        <p>
          Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des
          Vertragsabschlusses.
        </p>
        <p>
          Um Ihr Widerrufsrecht auszuüben, müssen Sie uns
        </p>
        <address className="not-italic block bg-[#12141C] border border-[#1E212B] rounded-lg p-4 text-zinc-200 text-sm">
          Gökhan Tan<br />
          Jägerhofallee 34<br />
          71638 Ludwigsburg<br />
          Deutschland<br />
          E-Mail: pineforgeai@gmx.de<br />
          Telefon: +49-160-4526226
        </address>
        <p>
          mittels einer eindeutigen Erklärung (z. B. ein mit der Post
          versandter Brief oder eine E-Mail) über Ihren Entschluss, diesen
          Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte{" "}
          <Link
            to="/cancellation-form"
            className="text-blue-400 hover:text-blue-300 underline underline-offset-2"
          >
            Muster-Widerrufsformular
          </Link>{" "}
          verwenden, das jedoch nicht vorgeschrieben ist.
        </p>
        <p>
          Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung
          über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist
          absenden.
        </p>
      </Section>

      <Section title="Folgen des Widerrufs">
        <p>
          Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen,
          die wir von Ihnen erhalten haben, unverzüglich und spätestens
          binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die
          Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen
          ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel,
          das Sie bei der ursprünglichen Transaktion eingesetzt haben, es
          sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart;
          in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte
          berechnet.
        </p>
      </Section>

      <Section title="Besondere Hinweise für digitale Dienstleistungen">
        <p>
          Bei einem Vertrag über die Bereitstellung von digitalen Inhalten
          bzw. digitalen Dienstleistungen (dazu zählt insbesondere die
          Bereitstellung von Credits sowie die sofortige Nutzbarkeit der
          KI-gestützten Skript-Generierung) kann das Widerrufsrecht
          vorzeitig erlöschen, wenn Sie
        </p>
        <ol className="list-decimal pl-6 space-y-1.5">
          <li>
            ausdrücklich zustimmen, dass mit der Ausführung des Vertrags vor
            Ablauf der Widerrufsfrist begonnen wird, und
          </li>
          <li>
            zugleich bestätigen, dass Sie Ihre Kenntnis davon haben, dass
            Sie durch diese Zustimmung mit Beginn der Ausführung Ihr
            Widerrufsrecht verlieren.
          </li>
        </ol>
        <p className="text-zinc-400 text-xs">
          Diese Zustimmungs- und Bestätigungserklärung wird gegebenenfalls
          im Checkout eingeholt, sobald der kostenpflichtige Checkout
          aktiviert ist.
        </p>
      </Section>

      <Section title="Muster-Widerrufsformular">
        <p>
          Ein Muster-Widerrufsformular finden Sie unter{" "}
          <Link
            to="/cancellation-form"
            className="text-blue-400 hover:text-blue-300 underline underline-offset-2"
          >
            /cancellation-form
          </Link>
          . Die Nutzung ist freiwillig.
        </p>
      </Section>

      <p className="text-zinc-500 text-xs pt-4 border-t border-[#1E212B]">
        Hinweis: Diese Widerrufsbelehrung ist ein Platzhalter-Entwurf und
        muss vor Aktivierung des kostenpflichtigen Checkouts einer
        abschließenden rechtlichen Prüfung unterzogen werden.
      </p>
    </LegalPage>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="text-lg font-semibold text-white mb-3">{title}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
